/** Seuil en pixels pour considérer que l'utilisateur est en bas du fil */
export const U3204_SCROLL_BOTTOM_THRESHOLD_PX = 50;

export function u3204IsScrolledToBottom(container: HTMLElement, thresholdPx = U3204_SCROLL_BOTTOM_THRESHOLD_PX): boolean {
  const distanceFromBottom = container.scrollHeight - container.scrollTop - container.clientHeight;
  return distanceFromBottom <= thresholdPx;
}

export function u3204ScrollToBottom(container: HTMLElement, behavior: ScrollBehavior = 'smooth'): void {
  container.scrollTo({ top: container.scrollHeight, behavior });
}
